class VariantSelector {
    constructor() {
  this.variantSwatches = {
    "Asphalt": { hex: "#6c6864" },
    "Athletic Heather": { hex: "#d5d5d5" },
    "Black": { hex: "#000000" },
    "Dark Grey Heather": { hex: "#5f6366" },
    'White/ Denim': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Denim2.jpg?v=1749844663' },
    "Antique Denim": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Antique-Denim.jpg?v=1751310039' },
    "Black/ Heather Grey": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black-Heather-Grey.jpg?v=1751317333' },
    "Heather": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather.jpg?v=1751399473' },
     "Apple": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Apple.jpg?v=1751402430' },
     "Ballerina": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Ballerina.jpg?v=1751402429' },
     "Banana": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Banana.jpg?v=1751402429' },
     "Caribbean": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Caribbean.jpg?v=1751402430' },
     "Cobalt": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Cobalt.jpg?v=1751402429' },
     "Key Lime": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Key-Lime.jpg?v=1751402430' },
    "Coyote Brown": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Coyote-Brown.jpg?v=1751399853' },
    "Granite Heather": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Granite-Heather.jpg?v=1751399853' },
    "Rouge": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Rouge.jpg?v=1751399853' },
    "Bamboo Blackout": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Bamboo-Blackout.jpg?v=1751402014' },
    "Bermuda Blackout": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Bermuda-Blackout.jpg?v=1751402015' },
    "Storm Camo": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Storm-Camo.jpg?v=1751402014' },
    "Vintage Hot Pink": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Vintage-Hot-Pink.jpg?v=1751402014' },
    "Haze Tie Dye": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Haze-Tie-Dye.jpg?v=1751401753' },
    "Island Tie Dye": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Island-Tie-Dye.jpg?v=1751401753' },
    "Rose Tie Dye": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Rose-Tie-Dye.jpg?v=1751401753' },
    "Sky Tie Dye": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Sky-Tie-Dye.jpg?v=1751401753' },
    "Black Leopard": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black-Leopard.jpg?v=1751401239' },
    "Mauvelous Spot": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Mauvelous-Spot.jpg?v=1751401239' },
    "Rainbow Stripe": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Rainbow-Stripe.jpg?v=1751401239' },
    "Shadow Stripe": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Shadow-Stripe.jpg?v=1751401239' },
    "Tradewind Spot": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Tradewind-Spot.jpg?v=1751401239' },
    "White Spot": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Spot.jpg?v=1751401239' },
    "Chill": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Chill.jpg?v=1751400697' },
    "Titanium": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Titanium.jpg?v=1751400697' },
    "Vintage Camo": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Vintage-Camo.jpg?v=1751399853' },
    "Vintage Smoke": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Vintage-Smoke.jpg?v=1751399853' },
    "Mauvelous": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Mauvelous.jpg?v=1751399473' },
    "Natural Heather": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Natural-Heather.jpg?v=1751399473' },
    "Saltwater": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Saltwater.jpg?v=1751399473' },
    "Heather Grey/ Cancun": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Grey--Cancun.jpg?v=1751317333' },
    "Ash": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Ash.jpg?v=1751310039' },
    "Heather Light Pink": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Light-Pink.jpg?v=1751318250' },
    "Ice Blue": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Ice-Blue.jpg?v=175131825' },
    "Heather Light Pink": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Light-Pink.jpg?v=1751318250' },
    "Cool Blue": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Cool-Blue.jpg?v=1751310717' },
    "Shiraz": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Shiraz.jpg?v=1751310040' },
    "Banana Cream": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Banana-Cream.jpg?v=1751314189' },
    "Bondi Blue": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Bondi-Blue.jpg?v=1751314189' },
    "Silk": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Silk.jpg?v=1751314189' },
     "Envy Sleeves/ Heather White Body": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Envy-Sleeves--Heather-White-Body.jpg?v=1751316500' },
     "Envy Sleeves/ Premium Heather Body": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Envy-Sleeves-Premium-Heather-Body.jpg?v=1751316500' },
     "Heather White/ Vintage Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-White--Vintage-Black.jpg?v=1751316500' },
     "Indigo Sleeves/ Heather White Body": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Indigo-Sleeves-Heather-White-Body.jpg?v=1751316500' },
     "Premium Heather Sleeves/ Heather White Body": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Premium-Heather-Sleeves-Heather-White-Body.jpg?v=1751316500' },
     "Premium Heather Sleeves/ Vintage Black Body": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Premium-Heather-Sleeves-Vintage-Black-Body.jpg?v=1751316500' },
     "Purple Rush Sleeves/ Heather White Body": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Purple-Rush-Sleeves--Heather-White-Body.jpg?v=1751316500' },
     "Tahiti Blue Sleeves/ Heather White Body": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Tahiti-Blue-Sleeves--Heather-White-Body.jpg?v=1751316500' },
     "Vintage Black Sleeves/ Heather White Body": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Vintage-Black-Sleeves--Heather-White-Body.jpg?v=1751316500' },
     "Vintage Black Sleeves/ Premium Heather Body": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Vintage-Black-Sleeves-Premium-Heather-Body.jpg?v=1751316500' },
     "Vintage Black Sleeves/ Vintage Black Body": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Vintage-Black-Sleeves--Vintage-Black-Body.jpg?v=1751316500' },
     "Vintage Navy Sleeves/ Premium Heather Body": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Vintage-Navy-Sleeves--Premium-Heather-Body.jpg?v=1751316500' },
     "Vintage Pink Sleeves/ Heather White Body": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Vintage-Pink-Sleeves--Heather-White-Body.jpg?v=1751316500' },
     "Vintage Purple Sleeves/ Heather White Body": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Vintage-Purple-Sleeves--Heather-White-Body.jpg?v=1751316500' },
     "Vintage Red Sleeves/ Heather White Body": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Vintage-Red-Sleeves-Heather-White-Body.jpg?v=1751316500' },
     "Vintage Red Sleeves/ Premium Heather Body": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Vintage-Red-Sleeves-Premium-Heather-Body.jpg?v=1751316500' },
     "Vintage Red Sleeves/ Vintage Black Body": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Vintage-Red-Sleeves--Vintage-Black-Body.jpg?v=1751316500' },
     "Vintage Royal Sleeves/ Heather White Body": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Vintage-Royal-Sleeves--Heather-White-Body.jpg?v=1751316500' },
     "Vintage Royal Sleeves/ Premium Heather Body": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Vintage-Royal-Sleeves-Premium-Heather-Body.jpg?v=1751316500' },
     "Envy": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Envy.jpg?v=1751311895' },
    "Washed Banana Cream": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Washed-Banana-Cream.jpg?v=1751313017' },
    "Washed Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Washed-Black.jpg?v=1751313017' },
    "Washed Cardinal": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Envy.jpg?v=1751311895' },
    "Washed Graphite Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Washed-Graphite-Black.jpg?v=1751313017' },
    "Washed Mauve": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Washed-Mauve.jpg?v=1751313017' },
    "Washed Military Green": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Washed-Military-Green.jpg?v=1751313017' },
    "Washed Natural": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Washed-Natural.jpg?v=1751313017' },
    "Washed Purple Rush": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Washed-Purple-Rush.jpg?v=1751313017' },
    "Washed Royal": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Washed-Royal.jpg?v=1751313017' },
    "Washed Royal Pine": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Washed-Royal-Pine.jpg?v=1751313017' },
    "Washed Stonewash Denim": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Washed-Stonewash-Denim.jpg?v=1751313017' },
    "Washed White": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Washed-White.jpg?v=1751313017' },
     "Heather White": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-White.jpg?v=1751311895' },
     "Indigo": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Indigo.jpg?v=1751311895' },
    "Cancun": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Cancun.jpg?v=1751312487' },
     "Premium Heather": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Premium-Heather.jpg?v=1751311895' },
     "Venetian Grey": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Venetian-Grey.jpg?v=1751311895' },
     "Vintage Light Orange": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Vintage-Light-Orange.jpg?v=1751311896' },
     "Vintage Lilac": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Vintage-Lilac.jpg?v=1751311895' },
     "Vintage Purple": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Vintage-Purple.jpg?v=1751311895' },
     "Vintage Royal": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Vintage-Royal.jpg?v=1751311895' },
     "Vintage Shocking Pink": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Vintage-Shocking-Pink.jpg?v=1751311895' },
     "Vintage Turquoise": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Vintage-Turquoise.jpg?v=1751311895' },
    "Cancun": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Vintage-Turquoise.jpg?v=1751311895' },
    "Smoked Paprika": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Smoked-Paprika.jpg?v=1751310040' },
    "Stonewash Denim": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Stonewash-Denim.jpg?v=1751310040' },
    "Stonewash Green": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Stonewash-Green.jpg?v=1751310039' },
    "Purple Rush": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Purple-Rush.jpg?v=1751310468' },
    "Tahiti Blue": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Tahiti-Blue.jpg?v=1751310468' },
    'Burgundy': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Burgundy.jpg?v=1750452510' },
    'Silver': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/silver.jpg?v=1750452510' },
    "Grey/ Maroon Triblend": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Grey-Maroon-Triblend.gif?v=1750005359' },
    "Heather Slate Blue": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Slate-Blue.jpg?v=1751309619' },
    "Cardinal": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Cardinal.jpg?v=1750793646' },
    "Heather Bay Blue": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Bay-Blue.jpg?v=1751308839' },
    "Heather Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Black.jpg?v=1751308839' },
    "Heather Midnight Navy": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Midnight-Navy.jpg?v=1751308839' },
    "Heather Military Green": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Military-Green.jpg?v=1751308839' },
    "Heather Teal": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Teal.jpg?v=1751308839' },
    "Canyon": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Canyon.jpg?v=1750793646' },
     "Heather Forest Green": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Forest-Green.jpg?v=1751307942' },
     "Heather Metal": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Metal.jpg?v=1751307943' },
     "Heavy Metal": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heavy-Metal.jpg?v=1751303584' },
     "Lead Grey": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Lead-Grey.jpg?v=1751303584' },
    "Creme": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Creme.jpg?v=1750793646' },
    "Antique Gold": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Antique-Gold.jpg?v=1751303280' },
    "Dark Heather Grey": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Dark-Heather-Grey.jpg?v=1751303279' },
    "Faded Army": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Faded-Army.jpg?v=1750795718' },
     "Midnight Navy": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Midnight-Navy.jpg?v=1751301754' },
    "Desert Pink": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Desert-Pink.jpg?v=1751302381' },
    "Oatmeal": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Oatmeal.jpg?v=1751302381' },
    "Graphite Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Graphite-Black.jpg?v=1751302915' },
    "Light Olive": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Light-Olive.jpg?v=1751302915' },
    "Shiitake": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Shiitake.jpg?v=1751302915' },
    "Royal Pine": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Royal-Pine.jpg?v=1751302381' },
    "Faded Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Faded-Black.jpg?v=1750795719' },
    "Faded Brown": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Faded-Brown.jpg?v=1750795718' },
    "Faded Cream": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Faded-Cream.jpg?v=1750795719' },
    "Faded Mustard": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Faded-Mustard.jpg?v=1750795719' },
    "Faded Navy": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Faded-Navy.jpg?v=1750795718' },
    "True Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/True-Black.jpg?v=1750797960' },
    "Bone": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Bone.jpg?v=1750786197' },
    "Tri-Coral": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Tri-Coral.jpg?v=1750793448' },
    "Tri-Cream": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Tri-Cream.jpg?v=1750793448' },
    "Tri-Dusk": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Tri-Dusk.jpg?v=1750793448' },
    "Tri-Olive": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Tri-Olive.jpg?v=1750793447' },
    "Tri-Rust": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Tri-Rust.jpg?v=1750793447' },
    "Tri-Storm": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Tri-Storm.jpg?v=1750793448' },
    "Sueded Arctic": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Sueded-Arctic.jpg?v=1750787061' },
    "Sueded Asphalt": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Sueded-Asphalt.jpg?v=1750787061' },
    "Sueded Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Sueded-Black.jpg?v=1750787061' },
    "Sueded Lieutenant": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Sueded-Lieutenant.jpg?v=1750787061' },
    "Sueded Navy": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Sueded-Navy.jpg?v=1750787061' },
    "Sueded White": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Sueded-White.jpg?v=1750787061' },
    "Gravel": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Gravel.jpg?v=1750786197' },
    "Rust": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Rust.jpg?v=1750787639' },
    "Smokey Violet": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Smokey-Violet.jpg?v=1750787639' },
    "Heather Bone/ Heather Army": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Bone--Heather-Army.jpg?v=1750787405' },
    "White/ Heather Cardinal": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Heather-Cardinal.jpg?v=1750787405' },
    "White/ Heather Indigo": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White--Heather-Indigo.jpg?v=1750787405' },
    "White/ Heather Mustard": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Heather-Mustard.jpg?v=1750787405' },
    "White/Heather Arctic": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Heather-Arctic.jpg?v=1750787405' },
    "Heather Lilac": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Lilac.jpg?v=1750786391' },
    "Army": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Army.jpg?v=1750784285' },
    "Powder Blue": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Powder-Blue.jpg?v=1750787551' },
    "Cream": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Cream.jpg?v=1750785139' },
    "Blush": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Blush.jpg?v=1750787768' },
     "Arctic": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Arctic.jpg?v=1750786758' },
    "Celadon": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Celadon.jpg?v=1750786624' },
    "Eggplant": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Eggplant.jpg?v=1750786623' },
    "Super Pink": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Super-Pink.jpg?v=1750786624' },
    "Lieutenant": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Lieutenant.jpg?v=1750785139' },
    "Heather Arctic": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Arctic.jpg?v=1750785805' },
    "Heather Army": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Army.jpg?v=1750785804' },
    "Heather Blush": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Blush.jpg?v=1750785804' },
    "Heather Bone": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Bone.jpg?v=1750785804' },
    "Heather Cardinal": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/American-Apparel.jpg?v=1750785804' },
    "Heather Indigo": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Indigo.jpg?v=1750785804' },
    "Heather Khaki": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Khaki.jpg?v=1750785804' },
    "Sea Blue": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Sea-Blue.jpg?v=1750785139' },
    "Athletic Grey": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Athletic-Grey.jpg?v=1750784416' },
    "Tri-Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Tri-Black.jpg?v=1750784416' },
    "Tri-Evergreen": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Tri-Evergreen.jpg?v=1750784416' },
    "Tri-Oatmeal": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Tri-Oatmeal.jpg?v=1750784416' },
    "Ash Grey": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Ash-Grey.jpg?v=1750783023' },
    "Truffle": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Truffle.jpg?v=1750784733' },
    "Aqua": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Aqua.jpg?v=1750784038' },
    "Grass": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Grass.jpg?v=1750784038' },
    "New Silver": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/New-Silver.jpg?v=1750784038' },
    "Sunshine": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Sunshine.jpg?v=1750784039' },
    "Athletic Blue": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Athletic-Blue.jpg?v=1750783557' },
    "Tri-Coffee": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Tri-Coffee.jpg?v=1750783557' },
    "Tri-Cranberry": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Tri-Cranberry.jpg?v=1750783557' },
    "Tri-Indigo": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Tri-Indigo.jpg?v=1750783557' },
    "Tri-Lemon": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Tri-Lemon.jpg?v=1750783557' },
    "Tri-Orchid": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Tri-Orchid.jpg?v=1750783558' },
    "Cranberry": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Cranberry.jpg?v=1750783023' },
    "Lapis": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Lapis.jpg?v=1750783023' },
    "Lemon": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Lemon.jpg?v=1750783023' },
     "Black Aqua": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black-Aqua.jpg?v=1750783308' },
     "Heather Kelly Green": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Kelly-Green.jpg?v=1750783308' },
    "Natural/ Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Natural-Black.jpg?v=1750537161' },
    "Natural/ Light Pink": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Natural-Light-Pink.jpg?v=1750537161' },
    "Natural/ Lime": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Natural-Lime.jpg?v=1750537161' },
    "Natural/ Maroon": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Natural--Maroon.jpg?v=1750537161' },
    "Natural/ Natural": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/natural.jpg?v=1750537161' },
    "Natural/ Navy": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Natural-Navy.jpg?v=1750537161' },
    "Natural/ Purple": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Natural-Purple.jpg?v=1750537161' },
    "Natural/ Red": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Natural--Red.jpg?v=1750537161' },
    "Natural/ Royal": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Natural-Royal.jpg?v=1750537161' },
    "Texas Orange": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Texas-Orange.jpg?v=1750537473' },
    "Lime": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/LIME.jpg?v=1750535463' },
    "Lavender": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Lavender.jpg?v=1750535590' },
    "Black/ Natural/ Light Grey": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black--Natural--Light-Grey.jpg?v=1750536105' },
    "Chocolate/ Natural/ Khaki": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Chocolate--Natural-Khaki.jpg?v=1750536105' },
    "Forest/ Natural/ Khaki": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Forest-Natural-Khaki.jpg?v=1750536105' },
    "Maroon/ Natural/ Light Pink": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Maroon-Natural-light-Pink.jpg?v=1750536105' },
    "Navy/ Natural/ Carolina Blue": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Navy-Natural-Carolina-Blue.jpg?v=1750536105' },
    "Navy/ Natural/ Red": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Navy-Natural-Red.jpg?v=1750536105' },
    "Purple/ Natural/ Lavender": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Purple-Natural-Lavender.jpg?v=1750536105' },
    "Hot Pink": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Hot-Pink.jpg?v=1750534617' },
    "Navy Blue": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Navy-Blue.jpg?v=1750534926' },
    "Cloudy Blue": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Cloudy-Blue.jpg?v=1750535222' },
    "Cotton Candy": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Cotton-Candy.jpg?v=1750535222' },
    "Pink Lady": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Pink-Lady.jpg?v=1750535221' },
    "Stormy Ash": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Stormy-Ash.jpg?v=1750535221' },
    "Lime Green": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Lime-Green.jpg?v=1750534617' },
    "Heather Charcoal": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Charcoal.jpg?v=1750452687' },
    "Kelly Green": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Kelly-Green.jpg?v=1750452687' },
    "Grey/ Navy Triblend": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Grey--Navy-Triblend.gif?v=1750005359' },
    "Heather Charcoal/ Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Charcoal-Black.jpg?v=1750452877' },
    "White/ Heather Peach": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Heather-Peach.gif?v=1750005359' },
    "White/ True Royal": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-True-Royal.gif?v=1750005359' },
     "Steel Grey": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Steel-Grey.jpg?v=1750534194' },
    "White/ Kelly": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Kelly.gif?v=1750005359' },
    "White/ Maroon": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Maroon.gif?v=1750005359' },
    "White/ Navy": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Navy_28adae0a-ad8e-4406-8f40-dde52bb12ed5.gif?v=1750005359' },
    "White/ Neon Orange": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Neon-Orange.gif?v=1750005359' },
    "White/ Neon Pink": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Neon-Pink.gif?v=1750005359' },
    "White/ Neon Yellow": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Neon-Yellow.gif?v=1750005359' },
    "White/ Red": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Red.gif?v=1750005359' },
    "White/ Denim": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Denim.gif?v=1750005359' },
    "White/ Heather Olive": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Heather-Olive.gif?v=1750005359' },
    "Grey/ Red Triblend": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Grey-Red-Triblend.gif?v=1750005359' },
    "Grey/ True Royal Triblend": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Grey-True-Royal-Triblend.gif?v=1750005359' },
    "White Fleck/ Charcoal Triblend": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Fleck--Charcoal-Triblend.gif?v=1750005359' },
    "White Fleck/ Navy Triblend": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Fleck-Navy-Triblend.gif?v=1750005359' },
    "White/ Asphalt": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Asphalt.gif?v=1750005359' },
    "White/ Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Black.gif?v=1750005359' },
    "White/ Deep Heather": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White--Deep-Heather.gif?v=1750005359' },
    "Sport Grey/ Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Sport-Grey-Black.gif?v=1749939676' },
    "Asphalt Slub": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Asphalt-Slub.jpg?v=1750274018' },
    "Peach": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Peach.jpg?v=1750274329' },
    "Cardinal Triblend": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Cardinal-Triblend.jpg?v=1750274468' },
     "Black Mineral Wash": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black-Mineral-Wash_1409c42f-9170-4430-9bbc-a7ce5601fae5.jpg?v=1750274837' },
    "Black Heather Triblend": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black-Heather-Triblend.jpg?v=1750274647' },
    "Sport Grey/ Navy": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Sport-Grey-Navy.gif?v=1749939677' },
    "Sport Grey/ Red": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Sport-Grey--Red.gif?v=1749939676' },
    "Athletic Heather/ Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Athletic-Heather-Black.jpg?v=1750275857' },
    "Deep Heather/ Dark Grey Heather": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Deep-Heather--Dark-Grey-Heather.jpg?v=175027610' },
    "White/ Baby Blue": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White--Baby-Blue.jpg?v=1750275857' },
    "White/ Pink": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White--Pink.jpg?v=1750275857' },
     "Athletic Heather/ Navy": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Athletic-Heather--Navy.jpg?v=1750275150' },
    "Heather Red/ Deep Heather": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Red--Deep-Heather.jpg?v=1750275150' },
    "Heather True Royal/ Navy": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-True-Royal-Navy.jpg?v=1750275150' },
     "White/ Athletic Heather": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Athletic-Heather.jpg?v=1750275151' },
    "Dark Grey Heather/ Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Dark-Grey-Heather-Black.jpg?v=1750275150' },
    "Sport Grey/ Royal": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Sport-Grey-Royal.gif?v=1749939676' },
    "White/ Forest Green": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Forest-Green.gif?v=1749939676' },
     "Black Mineral Wash": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black-Mineral-Wash.jpg?v=1750272684' },
     "Charcoal Black Slub": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Charcoal-Black-Slub.jpg?v=1750272684' },
     "Denim Slub": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Denim-Slub_bb01f9ba-d449-462b-ac23-8e20c7ac931c.jpg?v=1750272684' },
     "Forest Marble": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Forest-Marble.jpg?v=1750272684' },
     "Maroon Marble": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Maroon-Marble.jpg?v=1750272684' },
     "Navy Marble": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Navy-Marble.jpg?v=1750272684' },
     "Navy Slub": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Navy-Slub_d001c011-94ff-4c72-a939-d2c4013a8de1.jpg?v=1750272684' },
     "Olive Slub": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Olive-Slub.jpg?v=1750272684' },
     "Solid Black Slub": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Solid-Black-Slub.jpg?v=1750272684' },
     "Stone Marble": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Stone-Marble.jpg?v=1750272684' },
    "White/ Heliconia": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Heliconia.gif?v=1749939676' },
    "White/ Navy": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Navy.gif?v=1749939676' },
     "White/ Royal": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Royal.gif?v=1749939676' },
    "Black Heather/ Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black-Heather-Black.gif?v=1750006417' },
    "Black Marble/ Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black-Marble-Black.gif?v=1750006418' },
    "Black/ Deep Heather": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black-Deep-Heather.gif?v=1750006417' },
      "Black/ Red": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black-Red.gif?v=1750006417' },
    "Black/ True Royal": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black-True-Royal.gif?v=1750006418' },
  "Black/ White": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black-White.gif?v=1750005359' },
    "Deep Heather/ Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Deep-Heather--Black.gif?v=1750005359' },
    "Grey/ Charcoal Black Triblend": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Grey--Charcoal-Black-Triblend.gif?v=1750005359' },
    "Grey/ Emerald Triblend": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Grey-Emerald-Triblend.gif?v=1750005359' },
        'White/ Red': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Red.jpg?v=1749844579' },
          'White/ Black': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Black.jpg?v=1749844746' },
            'White/ Heather Peach': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Heather-Peach.jpg?v=1749845183' },
              'Blue Marble': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Blue-Marble.jpg?v=1749845368' },
    "Black Ink Heather/ Black Ink": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black-Ink-Heather--Black-Ink.gif?v=1750102663' },
     "Charcoal/ Black Ink": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Charcoal--Black-Ink.jpg?v=1750282043' },
    "Black Ink/ White": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black-Ink-White.gif?v=1750102663' },
    "Charcoal Marble": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Charcoal-Marble.gif?v=1750265640' },
    "True Royal Marble": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/True-Royal-Marble.gif?v=1750265640' },
    "Berry Triblend": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Berry-Triblend.gif?v=1750265819' },
    "Red Marble": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Red-Marble.jpg?v=1750265963' },
     "Solid Black Triblend": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Solid-Black-Triblend.jpg?v=1750269622' },
    "Solid White Triblend": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Solid-White-Triblend.jpg?v=1750269622' },
    "Sweet Cream Heather/ Blush Pink": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Sweet-Cream-Heather-Blush-Pink.gif?v=1750102663' },
    "Sweet Cream Heather/ Heather Mauve": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Sweet-Cream-Heather-Heather-Mauve.gif?v=1750102663' },
    "Sweet Cream Heather/ Indigo Heather": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Sweet-Cream-Heather-Indigo-Heather.gif?v=1750102663' },
    "White/ Black Ink": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Black-Ink.gif?v=1750102663' },
    "Heather Yellow Gold": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Yellow-Gold.jpg?v=1750270188' },
    "White/ Charcoal Heather": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White--Charcoal-Heather.gif?v=1750102663' },
    "White/ J. Navy": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-J.-Navy.gif?v=1750102663' },
    "White/ Scuba Blue": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Scuba-Blue.gif?v=1750102663' },
    "White/ True Red": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-True-Red.gif?v=1750102663' },
                'Black Marble': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black-Marble.jpg?v=1749846448' },
    'White Marble': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Marble.jpg?v=1749843856' },
      'Graphite Heather': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Graphite-Heather.jpg?v=1749852538' },
        'Sport Grey': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Sport-Grey.jpg?v=1749854342' },
          'Heather Red': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Red.jpg?v=1749854504' },
            'Heather Grey': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Grey.jpg?v=1749854594' },
   'Antique Gold Heather': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Antique-Gold-Heather.jpg?v=1750451370' },
     'Agave Heather': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Agave-Heather.jpg?v=1750451370' },
     'Athletic Heather': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Athletic-Heather.jpg?v=1750451370' },
     'Brown Heather': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Brown-Heather.jpg?v=1750451370' },
     'Burgundy Heather': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Burgundy-Heather.jpg?v=1750451370' },
     'Cactus Flower Heather': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Cactus-Flower-Heather.jpg?v=1750451370' },
     'Kelly Heather': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Kelly-Heather.jpg?v=1750451370' },
     'Navy Heather': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Navy-Heather.jpg?v=1750451370' },
     'Olive Heather': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Olive-Heather.jpg?v=1750451370' },
     'Peach Heather': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Peach-Heather.jpg?v=1750451370' },
     'Red Heather': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Red-Heather.jpg?v=1750451371' },
    'Royal Heather': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Royal-Heather.jpg?v=1750451371' },
    'Turquoise Heather': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Turquoise-Heather.jpg?v=1750451370' },
    'Athletic Blue Tri Blend': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Athletic-Blue-Tri-Blend.jpg?v=1750454486' },
    'Berry Tri Blend': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Berry-Tri-Blend.jpg?v=1750454486' },
    'Graphite B': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Graphite-B.jpg?v=1750454486' },
    'Graphite Tri Blend': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Graphite-Tri-Blend.jpg?v=1750454486' },
    'Heather B': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-B.jpg?v=1750454486' },
    'Heather Tri Blend': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Tri-Blend.jpg?v=1750454486' },
    'Grape Leaf': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Grape-Leaf.jpg?v=1750457270' },
    'Inked India': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Inked-India.jpg?v=1750457270' },
    'Lilac B': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Lilac-B.jpg?v=1750454486' },
    'Lilac Tri Blend': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Lilac-Tri-Blend.jpg?v=1750454486' },
    'Midnight Tri Blend': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Midnight-Tri-Blend.jpg?v=1750454486' },
    'Mocha Tri Blend': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Mocha-Tri-Blend.jpg?v=1750454486' },
    'Seafoam Tri Blend': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Seafoam-Tri-Blend.jpg?v=1750454487' },
     'Heather Athletic Blue': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Athletic-Blue.jpg?v=1750455893' },
     'Heather Brown': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Brown.jpg?v=1750455893' },
     'Heather Fuchsia': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Fuchsia.jpg?v=1750455893' },
     'Heather Green': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Green.jpg?v=1750455893' },
     'Heather Orange': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Orange.jpg?v=1750455893' },
     'Heather Pink': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Pink.jpg?v=1750455893' },
    'Heather Light Blue': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Light-Blue.jpg?v=1750456328' },
    'Fuchsia': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Fuchsia.jpg?v=1750456692' },
    'Heather Denim': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Denim.jpg?v=1750456692' },
    'Heather Kelly': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Kelly.jpg?v=1750456559' },
    'Cardinal Tri Blend': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Cardinal-Tri-Blend.jpg?v=1750457556' },
    'Denim Tri Blend': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Denim-Tri-Blend.jpg?v=1750457556' },
    'Graphite (disc)': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Graphite-_disc.jpg?v=1750457556' },
    'Heather (disc)': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-_disc.jpg?v=1750457556' },
    'Jade Tri Blend': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Jade-Tri-Blend.jpg?v=1750457556' },
    'Midnight B': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Midnight-B.jpg?v=1750457556' },
    'Military Tri Blend': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Military-Tri-Blend.jpg?v=1750457556' },
    'Brown': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Brown.jpg?v=1750458041' },
    'Royal (disc)': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Royal-_disc.jpg?v=1750458313' },
    'Solid Black Tri Blend': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Solid-Black-Tri-Blend.jpg?v=1750457556' },
      "Midnight": { hex: "#191970" },
    "Heather Purple (disc)": { "hex": "#76617E" },
  "Heather Royal": { "hex": "#6F98D8" },
    "Heather Royal (disc)": { "hex": "#456ABE" },
    "Amethyst": { "hex": "#9966CC" },
    "Aqua Triblend": { "hex": "#80b6a7" },
    "Heather Graphite": { "hex": "#4A5059" },
    "Cantaloupe": { "hex": "#FFB38E" },
  "Mellow Yellow": { "hex": "#F9BB44" },
  "Neo Mint": { "hex": "#CBECC2" },
  "Purist Blue": { "hex": "#BAE6EF" },
    "Atlantic": { "hex": "#5a7882" },
    "Cloud Heather": { "hex": "#9eb5cb" },
    "Athletic Grey Triblend": { "hex": "#a4a7a8" },
    "Athletic Heather/Black": { "hex": "#898D8D" },
    "Azalea": { "hex": "#dd74a1" },
    "Baby Blue": { "hex": "#69b3e7" },
    "Berry": { "hex": "#A63A79" },
    "Black Heather": { "hex": "#2E2E2E" },
    "Black Ink": { "hex": "#292929" },
    "Black Ink Heather": { "hex": "#535456" },
    "Black Speckled": { "hex": "#3a3a3a" },
    "Black/Deep Heather": { "hex": "#4b4f54" },
    "Blue Dusk": { "hex": "#253746" },
    "Blue Jean": { "hex": "#5B6E7D" },
    "Blue Triblend": { "hex": "#5b7d9c" },
    "Blush Pink": { "hex": "#e1b4b3" },
    "Brick": { "hex": "#7f3338" },
    "Brown Savana": { "hex": "#8b7d6b" },
    "Burnt Orange": { "hex": "#cc5500" },
    "Butter": { "hex": "#F6E27F" },
    "Cactus": { "hex": "#788a7a" },
    "J. Navy": { "hex": "#2c3e50" },
    "California Blue": { "hex": "#0091B3" },
    "Cardinal Red": { "hex": "#9D2235" },
    "Caribbean Blue": { "hex": "#00a9ce" },
    "Caribbean Mist": { "hex": "#00a9ce" },
    "Carolina Blue": { "hex": "#7ba4db" },
    "Carolina Heather": { "hex": "#a3b4c6" },
    "Cement": { "hex": "#aeaeae" },
    "Chalky Mint": { "hex": "#A8E6CF" },
    "Chambray": { "hex": "#3C6382" },
    "Charcoal": { "hex": "#66676c" },
    "Charcoal Black Triblend": { "hex": "#353631" },
    "Charcoal Grey": { "hex": "#737373" },
    "Charcoal/Black Ink": { "hex": "#4e4f51" },
    "Charity Pink": { "hex": "#f8a3bc" },
    "Charity Pink Triblend": { "hex": "#e789af" },
    "Cherry Red": { "hex": "#ac2b37" },
    "Citrine": { "hex": "#e4d00a" },
    "Classic Pink": { "hex": "#fbcadd" },
    "Clay": { "hex": "#b77f68" },
    "Cocoa": { "hex": "#5e4742" },
    "Coral": { "hex": "#ff7f50" },
    "Coral Silk": { "hex": "#fb637e" },
    "Crimson": { "hex": "#8C1C13" },
    "Crunchberry": { "hex": "#d95c81" },
    "Cyber Pink": { "hex": "#ff3399" },
    "Daisy": { "hex": "#fed101" },
    "Daisy Mist": { "hex": "#fed101" },
    "Dark Chocolate": { "hex": "#382f2d" },
    "Dark Grey": { "hex": "#4B4B4B" },
    "Dark Grey Heather/Black": { "hex": "#5f6162" },
    "Dark Heather": { "hex": "#425563" },
    "Dark Lavender": { "hex": "#734f96" },
    "Dark Navy": { "hex": "#00263a" },
    "Deep Heather": { "hex": "#696969" },
    "Deep Heather Speckled": { "hex": "#636363" },
    "Deep Purple": { "hex": "#4d227b" },
    "Deep Royal": { "hex": "#1a44b4" },
    "Denim Heather": { "hex": "#94a6b7" },
    "Dust": { "hex": "#bcae9e" },
    "Dusty Blue": { "hex": "#88a5b2" },
    "Dusty Rose": { "hex": "#e1bbb4" },
    "Espresso": { "hex": "#5C4033" },
    "Fern": { "hex": "#71bc78" },
    "Fiji Blue": { "hex": "#7d97a6" },
    "Flo Blue": { "hex": "#6981c0" },
    "Forest Green": { "hex": "#273b33" },
    "French Vanilla": { "hex": "#f7e5b3" },
    "Frost Grey Heather": { "hex": "#d3d3d6" },
    "Garnet": { "hex": "#7d2935" },
    "Gold": { "hex": "#eead1a" },
    "Golden Pecan": { "hex": "#bc987e" },
    "Green Triblend": { "hex": "#4e6155" },
    "Grey Triblend": { "hex": "#8e8e8e" },
    "Gunmetal": { "hex": "#939694" },
    "Heather Blue Lagoon": { "hex": "#6fa8bc" },
    "Heather Columbia Blue": { "hex": "#a3c9e2" },
    "Heather Deep Teal": { "hex": "#2a6266" },
    "Heather Dusty Blue": { "hex": "#a4b9ce" },
    "Heather Forest": { "hex": "#5a7164" },
    "Heather French Vanilla": { "hex": "#f4e7c7" },
    "Heather Irish Green": { "hex": "#5caa7f" },
    "Heather Maroon": { "hex": "#7e3a40" },
    "Heather Mustard": { "hex": "#eac75a" },
    "Heather Olive": { "hex": "#8B8C59" },
    "Heather Orchid": { "hex": "#b4a1b4" },
    "Heather Purple": { "hex": "#614b79" },
    "Heather Red/Deep Heather": { "hex": "#b2515b" },
    "Heather Sand Dune": { "hex": "#d1c2b0" },
    "Heather Slate": { "hex": "#708090" },
    "Heather Stone": { "hex": "#cfc6b8" },
    "Heather Sunset": { "hex": "#f2a591" },
    "Heather True Royal/Navy": { "hex": "#3d5a7d" },
    "Heliconia": { "hex": "#db3e79" },
    "Hibiscus": { "hex": "#e26a79" },
    "Hunter Green": { "hex": "#355E3B" },
    "Hydrangea": { "hex": "#B4D0EC" },
    "Ice Blue Triblend": { "hex": "#a2bacb" },
    "Independence Red": { "hex": "#932737" },
    "Irish Green": { "hex": "#00a74a" },
    "Ivory": { "hex": "#F3E8D1" },
    "Kelly Triblend": { "hex": "#008351" },
    "Lagoon Blue": { "hex": "#0077be" },
    "Lake": { "hex": "#546181" },
    "Lavender Blue": { "hex": "#c2c5e8" },
    "Leaf": { "hex": "#788753" },
    "Light Green": { "hex": "#5d8a75" },
    "Light Pink": { "hex": "#e4c6d4" },
    "Lilac": { "hex": "#b48fbf" },
    "Maroon Mist": { "hex": "#6d273c" },
    "Maroon Triblend": { "hex": "#800000" },
    "Mauve Triblend": { "hex": "#ab8a9a" },
    "Military Green Heather": { "hex": "#828770" },
    "Mint": { "hex": "#3eb489" },
    "Mint Green": { "hex": "#a0cfa8" },
    "Mint To Be": { "hex": "#b3d2c6" },
    "Mist": { "hex": "#E5E5E5" },
    "Mustard Triblend": { "hex": "#e5b550" },
    "Navy Mist": { "hex": "#2c4068" },
    "Navy Speckled": { "hex": "#2e3b4e" },
    "Navy Triblend": { "hex": "#3c4d69" },
    "Neon Cantaloupe": { "hex": "#FFA07A" },
    "Neon Green": { "hex": "#39ff14" },
    "Neon Lemon": { "hex": "#EFFF00" },
    "Neon Violet": { "hex": "#B026FF" },
    "Neon Yellow": { "hex": "#ffff33" },
    "Oatmeal Triblend": { "hex": "#e3dacb" },
    "Ocean": { "hex": "#0077be" },
    "Off White": { "hex": "#faf9f6" },
    "Olive": { "hex": "#808000" },
    "Olive Triblend": { "hex": "#6f6c4f" },
    "Orange": { "hex": "#f4633a" },
    "Orange Triblend": { "hex": "#f47f39" },
    "Orchid": { "hex": "#DA70D6" },
    "Oxford": { "hex": "#808080" },
    "Pale Yellow Triblend": { "hex": "#fef7d1" },
    "Peach Triblend": { "hex": "#f7b095" },
    "Peachy": { "hex": "#FFCBA4" },
    "Pebble Brown": { "hex": "#A49382" },
    "Pepper": { "hex": "#4D4C4A" },
    "Pink Lemonade": { "hex": "#f9d8d9" },
    "Pink Lemonade Mist": { "hex": "#ff8aad" },
    "Pistachio": { "hex": "#a9c47f" },
    "Pitch Black Mist": { "hex": "#2d2d2d" },
    "Plumrose": { "hex": "#c9809e" },
    "Purple": { "hex": "#464e7e" },
    "Purple Iris": { "hex": "#a490ba" },
    "Purple Storm": { "hex": "#6f5b7b" },
    "Purple Triblend": { "hex": "#6c4d7e" },
    "Putty": { "hex": "#d3c8b4" },
    "Raspberry": { "hex": "#e30b5d" },
    "Red Mist": { "hex": "#fb485b" },
    "Red Speckled": { "hex": "#c43c3c" },
    "Red Triblend": { "hex": "#b52b31" },
    "Rock": { "hex": "#8a8a8a" },
    "Royal Mist": { "hex": "#456db0" },
    "Sage": { "hex": "#819e87" },
    "Safety Green": { "hex": "#c6d219" },
    "Safety Orange": { "hex": "#e5801c" },
    "Safety Pink": { "hex": "#ff99cc" },
    "Sand": { "hex": "#c2b280" },
    "Sapphire": { "hex": "#0984b8" },
    "Scarlet Red": { "hex": "#ff2400" },
    "Scuba Blue": { "hex": "#00bfff" },
    "Seafoam": { "hex": "#9FE2BF" },
    "Seaglass": { "hex": "#a4c2a3" },
    "Slate Heather": { "hex": "#778899" },
    "Smoke": { "hex": "#3d3935" },
    "Soft Pink": { "hex": "#F6D1D1" },
    "Solid Baby Blue Blend": { "hex": "#89cff0" },
    "Solid Dark Grey Triblend": { "hex": "#696969" },
    "Solid Kelly Blend": { "hex": "#4cbb17" },
    "Solid Natural Blend": { "hex": "#f5f5dc" },
    "Solid Natural Triblend": { "hex": "#e7e2d4" },
    "Solid Navy Blend": { "hex": "#000080" },
    "Solid Navy Triblend": { "hex": "#3c4d69" },
    "Solid Pink Blend": { "hex": "#ffc0cb" },
    "Solid Red Blend": { "hex": "#ff0000" },
    "Solid White Blend": { "hex": "#F0F0F0" },
    "Steel Blue": { "hex": "#294f5a" },
    "Stone Blue": { "hex": "#92a1a9" },
    "Storm Grey": { "hex": "#898d8d" },
    "Sweet Cream Heather": { "hex": "#f2edd9" },
    "Synthetic Green": { "hex": "#6ECB63" },
    "Tan": { "hex": "#bd9a7a" },
    "Teal Ice": { "hex": "#b1e4e3" },
    "Teal Triblend": { "hex": "#008080" },
    "Team Purple": { "hex": "#800080" },
    "Terracotta": { "hex": "#fea38e" },
    "Toast": { "hex": "#D2B48C" },
    "True Navy": { "hex": "#29354f" },
    "True Royal Triblend": { "hex": "#002366" },
    "Turquoise": { "hex": "#40E0D0" },
    "Umber": { "hex": "#635147" },
    "Vintage Black": { "hex": "#1C1C1C" },
    "Vintage Brown": { "hex": "#8a7967" },
    "Vintage Heather Blue": { "hex": "#5a7e9e" },
    "Vintage Heather Navy": { "hex": "#4f5a69" },
    "Vintage Heather Red": { "hex": "#d86060" },
    "Vintage Navy": { "hex": "#4f5a69" },
    "Vintage Red": { "hex": "#b22222" },
    "Vintage White": { "hex": "#F9F9F1" },
    "Violet": { "hex": "#8094dd" },
    "Washed Denim": { "hex": "#6F8FAF" },
    "Washed Navy": { "hex": "#5e6a71" },
    "White Fleck Triblend": { "hex": "#e9e9e9" },
    "White Slub": { "hex": "#fafafa" },
    "White/Athletic Heather": { "hex": "#dcdcdc" },
    "White/Baby Blue": { "hex": "#c1e1f0" },
    "White/Denim": { "hex": "#d2d9e0" },
    "White/Heather Peach": { "hex": "#fde4d3" },
    "White/Kelly": { "hex": "#cde7c1" },
    "White/Pink": { "hex": "#ffe2e6" },
    "Wine": { "hex": "#722F37" },
    "Yam": { "hex": "#CC6B3D" },
    "Yellow": { "hex": "#f5e050" },
    "Yellow Gold Triblend": { "hex": "#e7c75a" },
    "Neon Pink": { hex: "#FF6EC7" },     
      "Neon Blue": { hex: "#0c51a3" },  
        "Terracotta": { hex: "#fea38e" },  
    "Pebble Brown": { hex: "#A49382" },
      "Independence Red": { hex: "#932737" },
        "Lake": { hex: "#546181" },
          "Blue Spruce": { hex: "#536964" },
            "Denim": { hex: "#535a68" },
          "Flo Blue": { hex: "#6981c0" },
          "Light Green": { hex: "#5d8a75" },
            "True Navy": { hex: "#29354f" },
      "Dark Grey":        { hex: "#4B4B4B" },     // Koyu gri, duman tonu
    "Forest":           { hex: "#228B22" },     // Koyu yeşil (orman yeşili)
    "Soft Pink":        { hex: "#F6D1D1" },     // Pudra pembe, yumuşak ton
    "Toast":            { hex: "#D2B48C" },     // Açık kahve, tost/bej arası
    "Vintage Black":    { hex: "#1C1C1C" },     // Hafif solgun siyah, yıkanmış efekt
    "Vintage White":    { hex: "#F9F9F1" },      // Kirli beyaz / nostaljik açık krem
    "Blue Jean":     { hex: "#5B6E7D" },
  "Butter":        { hex: "#F6E27F" },
    "Dusty Rose":        { hex: "#e1bbb4" },
  
    "Gunmetal":        { hex: "#939694" },
  "Maroon Mist":       { hex: "#6d273c" },
  "Navy Mist":          { hex: "#2c4068" },
  "Pitch Black": { hex: "#101820" },
  "Plumrose":         { hex: "#c9809e" },
  "Red Mist":   { hex: "#fb485b" },
  "Slate":        { hex: "#b3aaa4" },
  "Steel Blue":        { hex: "#294f5a" },
      "Cactus":        { hex: "#788a7a" },
  "Caribbean Mist":       { hex: "#00a9ce" },
  "Cement":          { hex: "#aeaeae" },
  "Daisy Mist": { hex: "#fed101" },
    "Daisy": { hex: "#fed101" },
      "Sage": { hex: "#819e87" },
        "Dark Navy": { hex: "#00263a" },
  "Pink Lemonade Mist":         { hex: "#ff8aad" },
  "Pitch Black Mist":   { hex: "#2d2d2d" },
  "Royal Mist":        { hex: "#456db0" },
  
      "Blue Dusk":        { hex: "#253746" },
  "Cherry Red":       { hex: "#ac2b37" },
  "Dark Chocolate":          { hex: "#382f2d" },
  "Deep Royal": { hex: "#1a44b4" },
  "Garnet":         { hex: "#7d2935" },
  "Tan":        { hex: "#bd9a7a" },
    "Charcoal":   { hex: "#66676c" },
  "Orange":        { hex: "#f4633a" },
    "Safety Orange":        { hex: "#e5801c" },
  "Carolina Blue":         { hex: "#7ba4db" },
  "Forest Green":   { hex: "#273b33" },
  "Gold":        { hex: "#eead1a" },
    "Brick":        { hex: "#7f3338" },
      "Dark Heather":        { hex: "#425563" },
  
    "Baby Blue":        { hex: "#69b3e7" },
  "Caribbean Blue":       { hex: "#00a9ce" },
  "Charity Pink":          { hex: "#f8a3bc" },
  "Heather Blue": { hex: "#3a5dae" },
  "Heather Dark Grey":         { hex: "#4e4f4a" },
  "Heather Navy":        { hex: "#333f48" },
  "Royal Blue":        { hex: "#1968c7" },
      "Smoke":        { hex: "#3d3935" },
  "Storm Grey":       { hex: "#898d8d" },
  "Teal Ice":          { hex: "#b1e4e3" },
  "True Red": { hex: "#bb1237" },
    "Azalea": { hex: "#dd74a1" },
      "Coral Silk": { hex: "#fb637e" },
  "Heliconia":       { hex: "#db3e79" },
      "Heather Irish Green": { hex: "#5caa7f" },
      "Heather Purple": { hex: "#614b79" },
  "Light Blue":          { hex: "#a4c8e1" },
  "Light Pink": { hex: "#e4c6d4" },
  "Mint Green":         { hex: "#a0cfa8" },
  "Pistachio":   { hex: "#a9c47f" },
  "Purple":        { hex: "#464e7e" },
  "Royal":        { hex: "#224d8f" },
    "Safety Green":   { hex: "#c6d219" },
  "Sapphire":        { hex: "#0984b8" },
    "Irish Green":        { hex: "#00a74a" },
      "Violet":        { hex: "#8094dd" },
  "Crimson":       { hex: "#8C1C13" },
  "Grey":          { hex: "#9A9A9A" },
  "Hydrangea": { hex: "#B4D0EC" },
  "Ivory":         { hex: "#F3E8D1" },
  "Neon Violet":   { hex: "#B026FF" },
  "Peachy":        { hex: "#FFCBA4" },
  "Pepper":        { hex: "#4D4C4A" },
  "Chalky Mint":   { hex: "#A8E6CF" },
  "Espresso":      { hex: "#5C4033" },
  "Yam":           { hex: "#CC6B3D" },
  "Seafoam":       { hex: "#9FE2BF" },
  "Wine":          { hex: "#722F37" },
  "Washed Denim":  { hex: "#6F8FAF" },
    "Heather Columbia Blue": { hex: "#a3c9e2" },
    "Heather Dust": { hex: "#e8dfd6" },
    "Heather Maroon": { hex: "#7e3a40" },
    "Heather Mauve": { hex: "#c9a9a6" },
    "Heather Stone": { hex: "#cfc6b8" },
    "Natural": { hex: "#f5f1e8" },
    "Navy": { hex: "#1a1d49" },
    "Pink": { hex: "#f9c3d0" },
    "Red": { hex: "#d02d2d" },
    "Storm": { hex: "#a1a1a1" },
    "True Royal": { hex: "#2b53a4" },
    "Black": { hex: "#000000" },
    "Heather Deep Teal": { hex: "#2a6266" },
    "Heather Dusty Blue": { hex: "#a4b9ce" },
    "Heather Mustard": { hex: "#eac75a" },
    "Heather Peach": { hex: "#f4c8b7" },
    "Heather Sunset": { hex: "#f2a591" },
    "Lavender Blue": { hex: "#c2c5e8" },
    "Lilac": { hex: "#b48fbf" },
    "Maroon": { hex: "#800000" },
    "Mauve": { hex: "#c9a9a6" },
    "Military Green": { hex: "#4b5320" },
    "Navy": { hex: "#1a1d49" },
    "Red": { hex: "#d02d2d" },
    "White": { hex: "#ffffff" },
    "Berry": { hex: "#A63A79" },
  "Black Heather": { hex: "#2E2E2E" },
  "Heather Olive": { hex: "#8B8C59" },
  "Heather Slate": { hex: "#708090" },
  "Heather True Royal": { hex: "#2B3856" },
  "Kelly": { hex: "#4CBB17" },
  "Mist": { hex: "#E5E5E5" },
  "Mustard": { hex: "#FFDB58" },
  "Slate Heather": { hex: "#778899" },
  "Solid Black Blend": { hex: "#2B2B2B" },
  "Solid White Blend": { hex: "#F0F0F0" },
  "Sunset": { hex: "#FFCC99" },
  "Synthetic Green": { hex: "#6ECB63" },
  "Team Purple": { hex: "#800080" },
  "Teal": { hex: "#008080" },
  "Turquoise": { hex: "#40E0D0" },
    "Cardinal Red": { hex: "#9D2235" },
  "Neon Cantaloupe": { hex: "#FFA07A" },
  "Neon Lemon": { hex: "#EFFF00" },
  "Orchid": { hex: "#DA70D6" },
  "Chambray": { hex: "#3C6382" },
    "Yellow": { hex: "#f5e050" }
  };
      
      this.selectedOptions = {
        color: null,
        quantities: {}
      };
      
      this.init();
    }
  
   init() {
    this.container = document.querySelector('.product-variant-selector');
    if (!this.container) return;
  
    this.productForm = document.querySelector('product-form');
    this.variantRadios = document.querySelector('variant-radios');
    this.variantSelects = document.querySelector('variant-selects');
  
    this.setupColorSwatches();
    this.setupQuantityControls();
    this.setupAddToCartButton();
    this.bindEvents();
  
    // YMQ dropdown değişince toplamı güncelle
    document.querySelectorAll('select[name^="ymq["]').forEach(select => {
      select.addEventListener('change', () => this.updateSummaryTable());
    });
  }
  
  
  
  
  updateSummaryTable() {
    const tableBody = document.getElementById('size-summary-body');
    if (!tableBody) return;
  
    let extraPerUnit = 0;
    try {
      const selectedOption = document.querySelector('select[name^="ymq["]')?.selectedOptions[0];
      if (selectedOption) {
        const extra = parseFloat(selectedOption.getAttribute('data-price'));
        if (!isNaN(extra)) extraPerUnit = extra;
      }
    } catch (e) {
      console.warn('YMQ price not found:', e);
    }
  
    // ✅ 1. Tüm adetleri topla
    const totalQty = Object.values(this.selectedOptions.quantities)
      .reduce((sum, qty) => sum + qty, 0);
  
    const discountActive = totalQty >= 100;
  
    tableBody.innerHTML = '';
  
    Object.entries(this.selectedOptions.quantities).forEach(([variantId, qty]) => {
      if (qty > 0) {
        const variant = window.productVariants.find(v => v.id == variantId);
        if (variant) {
          const baseUnitPrice = variant.price / 100;
          const finalUnitPrice = baseUnitPrice + extraPerUnit;
  
          let displayUnitPrice = '';
          let unitPriceToUse = finalUnitPrice;
  
          if (discountActive) {
            const discounted = finalUnitPrice / 2;
            const flooredDiscounted = Math.floor(discounted * 100) / 100;
            displayUnitPrice = `
              <span style="color:red; text-decoration: line-through;">
                ${this.formatMoney(finalUnitPrice * 100)}
              </span>
              <span style="margin-left: 6px;">
                ${this.formatMoney(flooredDiscounted * 100)}
              </span>`;
  
            unitPriceToUse = flooredDiscounted;
          } else {
            displayUnitPrice = this.formatMoney(finalUnitPrice * 100);
          }
  
          const total = Math.floor(unitPriceToUse * qty * 100) / 100;
  
          const row = document.createElement('tr');
          row.setAttribute('data-variant-id', variantId);
          row.innerHTML = `
            <td>${variant.option2}</td>  <!-- Size -->
            <td>${qty}</td>              <!-- Quantity -->
            <td>${displayUnitPrice}</td>
            <td>${this.formatMoney(Math.floor(total * 100))}</td>
          `;
          tableBody.appendChild(row);
        }
      }
    });
  }
  
  
  
  
  
  
  
  
    
    setupColorSwatches() {
    const colorVariants = this.getUniqueColorOptions();
    const swatchContainer = this.container.querySelector('.swatch-container');
    const variantLabel = this.container.querySelector('.variant-label');
  
    if (!swatchContainer || !variantLabel) return;
  
    // Variant label'ı container içine al
    const labelContainer = document.createElement('div');
    labelContainer.className = 'variant-label-container';
    variantLabel.parentNode.insertBefore(labelContainer, variantLabel);
    labelContainer.appendChild(variantLabel);
  
    // Selected color span'i ekle
    const selectedColorSpan = document.createElement('span');
    selectedColorSpan.className = 'selected-color';
    labelContainer.appendChild(selectedColorSpan);
  
    // Label metni
    variantLabel.textContent = 'Selected Color:';
  
    swatchContainer.innerHTML = '';
  
    colorVariants.forEach(color => {
      const swatch = document.createElement('div');
      swatch.className = 'swatch-element';
      swatch.setAttribute('data-color', color);
  
      // Tooltip
      const tooltip = document.createElement('span');
      tooltip.className = 'swatch-tooltip';
      tooltip.textContent = this.formatColorName(color);
      swatch.appendChild(tooltip);
  
      const swatchData = this.variantSwatches?.[color] || {};
  
      if (swatchData.img) {
        const img = document.createElement('img');
        img.src = swatchData.img;
        img.alt = this.formatColorName(color);
        swatch.appendChild(img);
      } else if (swatchData.hex) {
        swatch.style.backgroundColor = swatchData.hex;
      } else {
        // fallback renk
        swatch.style.backgroundColor = '#ccc';
      }
  
      swatchContainer.appendChild(swatch);
    });
  
    // İlk swatch'u otomatik seç
    const firstSwatch = swatchContainer.querySelector('.swatch-element');
    if (firstSwatch) {
      this.handleColorSelection(firstSwatch);
    }
  }
  
    updateSizeOptions(selectedColor) {
      const sizeGrid = this.container.querySelector('.size-grid');
      if (!sizeGrid) return;
  
      const colorVariants = window.productVariants.filter(v => v.option1 === selectedColor);
      
      sizeGrid.innerHTML = '';
      
      colorVariants.forEach(variant => {
        const variantData = document.querySelector(`[data-variant-inventory="${variant.id}"]`);
        const inventory = variantData ? parseInt(variantData.textContent) : 0;
        const isAvailable = inventory > 0;
        
        const sizeBox = document.createElement('div');
        sizeBox.className = `size-box${!isAvailable ? ' out-of-stock' : ''}`;
        sizeBox.setAttribute('data-value', variant.option2);
        sizeBox.setAttribute('data-variant-id', variant.id);
        
        let stockText = isAvailable ? `${inventory}` : 'OUT';
        let stockCount = isAvailable ? inventory : 0;
        
        sizeBox.innerHTML = `
          <div class="size-name">${variant.option2}</div>
      
          <div class="variant-stock">
            ${isAvailable ? 
              `<div class="quantity-controls">
                <button type="button" class="quantity-btn quantity-btn--minus">-</button>
                <input type="number" 
                       class="quantity-input" 
                       value="0" 
                       min="0" 
                       max="${stockCount}"
                       data-variant-id="${variant.id}">
                <button type="button" class="quantity-btn quantity-btn--plus">+</button>
              </div>
              <span class="stock-count"></span>` : 
              'OUT'}
          </div>
        `;
        
        sizeGrid.appendChild(sizeBox);
      });
      
      this.setupQuantityControls();
      this.updateTotalQuantity();
    }
  
    setupQuantityControls() {
      this.container.querySelectorAll('.quantity-controls').forEach(control => {
        // Önceki event listener'ları temizle
        const minusBtn = control.querySelector('.quantity-btn--minus');
        const plusBtn = control.querySelector('.quantity-btn--plus');
        const input = control.querySelector('.quantity-input');
        
        // Eski event listener'ları kaldır
        minusBtn.replaceWith(minusBtn.cloneNode(true));
        plusBtn.replaceWith(plusBtn.cloneNode(true));
        input.replaceWith(input.cloneNode(true));
        
        // Yeni elementleri seç
        const newMinusBtn = control.querySelector('.quantity-btn--minus');
        const newPlusBtn = control.querySelector('.quantity-btn--plus');
        const newInput = control.querySelector('.quantity-input');
        
        const variantId = newInput.dataset.variantId;
        const maxQuantity = parseInt(newInput.getAttribute('max')) || 9999;
  
        this.selectedOptions.quantities[variantId] = 0;
  
        // Yeni event listener'ları ekle
        newMinusBtn.addEventListener('click', (e) => {
          e.preventDefault(); // Form submit'i engelle
          const currentValue = parseInt(newInput.value) || 0;
          if (currentValue > 0) {
            newInput.value = currentValue - 1;
            this.selectedOptions.quantities[variantId] = currentValue - 1;
            this.updateTotalQuantity();
          }
        });
  
        newPlusBtn.addEventListener('click', (e) => {
          e.preventDefault(); // Form submit'i engelle
          const currentValue = parseInt(newInput.value) || 0;
          if (currentValue < maxQuantity) {
            newInput.value = currentValue + 1;
            this.selectedOptions.quantities[variantId] = currentValue + 1;
            this.updateTotalQuantity();
          }
        });
  
        newInput.addEventListener('change', () => {
          let value = parseInt(newInput.value) || 0;
          if (value < 0) value = 0;
          if (value > maxQuantity) value = maxQuantity;
          newInput.value = value;
          this.selectedOptions.quantities[variantId] = value;
          this.updateTotalQuantity();
        });
      });
  }
  
    updateTotalQuantity() {
      const totalQuantity = Object.values(this.selectedOptions.quantities)
        .reduce((sum, qty) => sum + qty, 0);
      
      const addToCartBtn = this.container.querySelector('.product-form__submit');
      if (addToCartBtn) {
        addToCartBtn.disabled = totalQuantity === 0;
        addToCartBtn.textContent = totalQuantity > 0 ? 'Add to Cart' : 'Select Options';
      }
  
      this.updateSummaryTable();
  
    }
  
    setupAddToCartButton() {
      const addToCartBtn = this.container.querySelector('.product-form__submit');
      if (addToCartBtn) {
        addToCartBtn.addEventListener('click', () => this.addToCart());
      }
    }
  
    bindEvents() {
      this.container.addEventListener('click', (e) => {
        const swatch = e.target.closest('.swatch-element');
        if (swatch) {
          this.handleColorSelection(swatch);
        }
      });
    }
  
   handleColorSelection(swatch) {
      const color = swatch.getAttribute('data-color');
      this.selectedOptions.color = color;
      
      // Selected color text'ini güncelle
      const selectedColorSpan = this.container.querySelector('.selected-color');
      if (selectedColorSpan) {
          selectedColorSpan.textContent = this.formatColorName(color);
      }
      
      // Swatch seçimini güncelle
      this.container.querySelectorAll('.swatch-element').forEach(el => {
          el.classList.remove('selected');
      });
      swatch.classList.add('selected');
      
      // Seçilen variant'ı bul
      const selectedVariant = window.productVariants.find(v => v.option1 === color);
      
      if (selectedVariant && selectedVariant.featured_media) {
          // Ana ürün resmini güncelle
          const mainImage = document.querySelector('.product__media img');
          if (mainImage) {
              mainImage.src = selectedVariant.featured_media.preview_image.src;
              mainImage.srcset = selectedVariant.featured_media.preview_image.src;
              
              // Eğer bir zoom/lightbox özelliği varsa onu da güncelle
              const zoomImage = document.querySelector('.product__media a');
              if (zoomImage) {
                  zoomImage.href = selectedVariant.featured_media.preview_image.src;
              }
          }
          
          // Media gallery'deki ilgili thumbnail'i seç (eğer varsa)
          const thumbnails = document.querySelectorAll('.product__media-list .product__media-item');
          thumbnails.forEach(thumb => {
              if (thumb.dataset.mediaId === selectedVariant.featured_media.id.toString()) {
                  thumb.click(); // Thumbnail'e tıklama efekti
              }
          });
      }
      
      this.updateSizeOptions(color);
      this.triggerVariantChange();
  }
  
    formatColorName(color) {
      return color.replace(/\s*-\s*\d+$/, '').trim();
    }
  
    triggerVariantChange() {
      if (!this.selectedOptions.color) return;
  
      const variant = window.productVariants.find(v => v.option1 === this.selectedOptions.color);
      if (!variant) return;
  
      if (this.variantRadios) {
        const input = this.variantRadios.querySelector(`input[value="${variant.id}"]`);
        if (input) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
  
      if (this.variantSelects) {
        const select = this.variantSelects.querySelector('select');
        if (select) {
          select.value = variant.id;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
  
      if (this.productForm) {
        const input = this.productForm.querySelector('input[name="id"]');
        if (input) {
          input.value = variant.id;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
  
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
  
   addToCart() {
    const items = [];
    let properties = {};
  
    try {
      properties = ymq_option.productInstance.getAjaxDataByFormData(); // App seçenekleri
    } catch (e) {
      console.warn('YMQ App properties alınamadı:', e);
    }
  
    Object.entries(this.selectedOptions.quantities).forEach(([variantId, quantity]) => {
      if (quantity > 0) {
        items.push({
          id: parseInt(variantId),
          quantity: quantity,
          properties: properties
        });
      }
    });
     
    if (items.length === 0) {
      alert('Please select at least one size and quantity');
      return;
    }
  
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ items })
    })
    .then(response => response.json())
    .then(() => {
      // YENİ EKLEDİK: Direkt cart sayfasına yönlendir
      window.location.href = '/cart';
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
  
  
    getUniqueColorOptions() {
      return [...new Set(window.productVariants.map(variant => variant.option1))];
    }
  
    formatMoney(cents) {
      return window.theme?.moneyFormat?.replace('{{amount}}', (cents/100).toFixed(2)) || `$${(cents/100).toFixed(2)}`;
    }
  }
  
  document.addEventListener('DOMContentLoaded', () => {
    new VariantSelector();
  });
  